import script from "./CategoryTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTabs.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTabs.vue?vue&type=style&index=0&id=50cc516e&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50cc516e"]])

export default __exports__